/**
 * Epic HR App State
 */
import { MutationTree, ActionTree, GetterTree } from 'vuex';

import { IEpicState } from './@types';

/**
 * State
 */
const state: IEpicState = {
	ehrScreen: 'splash',
	ehrActiveSection: 'epic-study-information',
	ehrActiveFrame: 'epic-study-overview',
	ehrSidebarActive: true,
	ehrActiveFrameIndex: 0
};

/**
 * Mutations
 */
const mutations: MutationTree<IEpicState> = {
	updateEhrScreen (stateObj: IEpicState, screen: string) {
		stateObj.ehrScreen = screen;
	},
	updateEhrActiveSection (stateObj: IEpicState, section: string) {
		stateObj.ehrActiveSection = section;
	},
	updateEhrActiveFrame (stateObj: IEpicState, frame: string) {
		stateObj.ehrActiveFrame = frame;
	},
	updateEhrSidebarActive (stateObj: IEpicState) {
		stateObj.ehrSidebarActive = !stateObj.ehrSidebarActive;
	},
	updateEhrActiveFrameIndex (stateObj: IEpicState, index: number) {
		stateObj.ehrActiveFrameIndex = index;
	}
};

/**
 * Getters
 */
const getters: GetterTree<IEpicState, any> = {
	get_ehrScreen (stateObj: IEpicState): string {
		return stateObj.ehrScreen;
	},
	get_ehrActiveSection (stateObj: IEpicState): string {
		return stateObj.ehrActiveSection;
	},
	get_ehrActiveFrame (stateObj: IEpicState): string {
		return stateObj.ehrActiveFrame;
	},
	get_ehrSidebarActive (stateObj: IEpicState): boolean {
		return stateObj.ehrSidebarActive;
	},
	get_ehrActiveFrameIndex (stateObj: IEpicState): number {
		return stateObj.ehrActiveFrameIndex;
	},
};

/**
 * Actions
 */
const actions: ActionTree<IEpicState, any> = {
	axn_updateEhrScreen (context: any, screen: string) {
		context.commit('updateEhrScreen', screen);
	},
	axn_updateEhrActiveSection (context: any, section: string) {
		context.commit('updateEhrActiveSection', section);
	},
	axn_updateEhrActiveFrame (context: any, frame: string) {
		context.commit('updateEhrActiveFrame', frame);
	},
	axn_updateEhrSidebarActive (context: any) {
		context.commit('updateEhrSidebarActive');
	},
	axn_updateEhrActiveFrameIndex (context: any, index: number) {
		context.commit('updateEhrActiveFrameIndex', index);
	},
};

/**
 * Export
 */
export default {
	namespace: true,
	state,
	mutations,
	getters,
	actions,
};
